<template>
  <div>
    <b-modal
      id="thouand-mentors-modal"
      ref="thouand-mentors-modal"
      centered
      size="xl"
      no-close-on-backdrop
      hide-footer
    >
      <img
        src="/1K_Mentors_1440x240_Desktop.jpg"
        alt="Thousand Mentors"
        class="img-fluid rounded d-none d-md-block"
        style="width:100%; object-fit: cover;"
      >

      <!-- Mobile image -->
      <img
        src="/1K_Mentors_420x180_Mobile.jpg"
        alt="Thousand Mentors"
        class="img-fluid rounded d-block d-md-none"
        style="width:100%; object-fit: cover;"
      >
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import {
  BModal,
} from 'bootstrap-vue'

export default {
  components: {
    BModal,
  },
  data() {
    return {

    }
  },
  methods: {
    show() {
      this.$refs['thouand-mentors-modal'].show()
    },
  },
}
</script>
